<template>
    <dx-load-panel
        :position="{ of: pai }" 
        :visible="visivelGeral"
        :show-indicator="true"
        :show-pane="false"
        :shading="sombra"
        :shadingColor="corSombraInt"
        :message="loadingMsg" 
        :hide-on-outside-click="false"
        :class="`loading-container-vistra ${loadingClass}`"
        :height="height"
        :width="width"
        :wrapperAttr="{id: id}"
        :container="pai"
        >
    </dx-load-panel>
</template>

<script>
    import { DxLoadPanel } from 'devextreme-vue';
    import { mapGetters } from 'vuex'
    export default {
        props: {
            visivel: {
                type: Boolean,
                default: false
            },
            pai: {
                default: undefined
            },
            sombra: {
                type: Boolean,
                default: false
            },
            corSombra: {
                type: String
            },
            loadingClass: {
                type: String,
                default: ""
            },
            tempoTimeout: {
                type: Number,
                default: 300
            },
            height: {
                type: [Number, String, Function],
                default: undefined
            },
            width: {
                type: [Number, String, Function],
                default: undefined
            },
            id: {
                type: String,
                default: "vis-loading"
            }
        },
        components: {
            DxLoadPanel
        },
        computed: {
            ...mapGetters(['tema']),
            loadingMsg() {
                return this.mensagens.length ? this.mensagens[this.mensagens.length-1] : ""
            },
            temMensagem() {
                return this.mensagens.length > 0
            },
            visivelWatch() {
                return this.visivel || this.temMensagem
            },
            corSombraInt() {
                return this.corSombra || (this.tema == 'tema-dark' ? 'rgba(0,0,0,0.4)' : 'rgba(255,255,255,0.4)')
            }
        },
        watch: {
            
            visivelWatch(newVal) {
                if (!newVal) {
                    this.visivelGeral = false
                    clearTimeout(this.timeoutAparece)
                }
                else {
                    this.timeoutAparece = setTimeout(() => {
                        if (this.visivelWatch)
                            this.visivelGeral = true
                    }, this.tempoTimeout);
                }
            },
            visivelGeral (newVal) {
                let _this = this
                if (newVal) {
                    if (!_this.mostraMsgInterval) {
                        _this.mostraMsgInterval = setInterval(function () {
                            if (!_this.visivelGeral) {
                                clearInterval(_this.mostraMsgInterval)
                                _this.mostraMsgInterval = 0
                                return
                            }
                            if (_this.mensagens.length > 0) {
                                _this.$vistra.showMessage(_this.mensagens[0] + "...", "info", { displayTime: 300 })
                            }
                        }, 100)
                    }
                }
            }
        },

        data() {
            return {
                mensagens: [],
                visivelGeral: this.visivel,
                timeoutAparece: null,
                mostraMsgInterval: null
            }
        },

        methods: {
            addMsg(msg) {
                this.mensagens.push(msg)
            },
            removeMsg(msg) {
                delete this.mensagens.splice(this.mensagens.indexOf(msg), 1)
            },
        }
    }
</script>

<style>
.loading-container-vistra {
    width: 0px!important;
    height: 0px!important;
}
</style>



